var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M683,295.3h-77.9c-9.1,0-17.7-3.9-23.7-10.6l-31.6-35.6c-4.7-5.3-11.5-8.3-18.6-8.3c-7.1,0-13.9,3-18.6,8.3l-27.1,30.5 c-8.9,10-21.6,15.7-35,15.7H23.7C11.6,329.8,3.7,366.3,0.5,404.1h402.8c7.1,0,13.9-2.9,18.8-8l37.5-39c4.7-4.9,11.2-7.6,17.9-7.6 h1.5c7.1,0,13.9,3,18.6,8.4l31.6,35.6c6,6.8,14.7,10.6,23.7,10.6h328.8c-3.2-37.8-11.1-74.3-23.2-108.7L683,295.3L683,295.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,632.7c7.1,0,13.9-2.9,18.8-8l37.5-39c4.7-4.9,11.2-7.6,17.9-7.6h1.5c7.1,0,13.9,3,18.6,8.3l31.6,35.6 c6,6.8,14.7,10.6,23.7,10.6h445.6c16.7-34.4,28.9-71.2,36.2-109.8H448c-9.1,0-17.7-3.9-23.7-10.6l-31.6-35.6 c-4.7-5.3-11.5-8.3-18.6-8.3c-7.1,0-13.9,3-18.6,8.3l-27.1,30.5c-8.9,10-21.6,15.7-35,15.7H6.6c7.3,38.6,19.5,75.5,36.2,109.8 L244.2,632.7L244.2,632.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.3,176.5c7.1,0,13.9-2.9,18.8-8l37.5-39c4.7-4.9,11.2-7.6,17.9-7.6h1.5c7.1,0,13.9,3,18.6,8.4l31.6,35.6 c6,6.8,14.7,10.6,23.7,10.6h84.7C714,69.6,585.7,0.5,441.1,0.5s-272.9,69.1-353.6,176H560.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.1,741.6H274.3c-9.1,0-17.7-3.9-23.7-10.6l-31.6-35.6c-4.7-5.3-11.5-8.3-18.6-8.3c-7.1,0-13.9,3-18.6,8.3l-27.1,30.5 c-8.9,10-21.6,15.7-35,15.7h-1.8c80.7,86.2,195.7,140.1,323.3,140.1s242.6-53.9,323.3-140.1L390.1,741.6L390.1,741.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptIcon);
export default __webpack_public_path__ + "static/media/apt_icon.d3ad8073f8a34aff91cc2020ec5b513f.svg";
export { ForwardRef as ReactComponent };